import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useTranslation } from 'react-i18next';
const MessageBanner = ({ type, children, cssClass }) => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: `message-banner ${type} ${cssClass}` }, { children: _jsxs("div", Object.assign({ className: "message-banner_wrapper" }, { children: [type === 'error' ? (_jsx(ErrorOutlineOutlinedIcon, {})) : type === 'info' ? (_jsx(InfoOutlinedIcon, {})) : type === 'warning' ? (_jsx(WarningAmberRoundedIcon, {})) : (_jsx(TaskAltRoundedIcon, {})), _jsx("div", Object.assign({ className: 'content-message' }, { children: children }))] })) })));
};
export default MessageBanner;
